export default __webpack_public_path__ + "static/media/DSC_1936.06fa6de7.jpg";